export const getPages = (current: number, total: number) => {
  const pages: (number | 'dots-before' | 'dots-after')[] = [];

  if (total <= 7) {
    for (let i = 1; i <= total; i++) pages.push(i);
    return pages;
  }

  pages.push(1);

  if (current <= 3) {
    pages.push(2, 3, 4);

    if (total > 5) {
      pages.push('dots-after');
      pages.push(total);
    }

    return pages;
  }

  if (current >= total - 2) {
    if (total > 5) {
      pages.push('dots-before');
    }

    for (let i = total - 3; i <= total; i++) {
      pages.push(i);
    }

    return pages;
  }

  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);

  if (start > 2) {
    pages.push('dots-before');
  }

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  if (end < total - 1) {
    pages.push('dots-after');
  }

  pages.push(total);

  return pages;
};
